import { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";
import { apiMe, apiLogin, apiRegister, apiLogout } from "@/lib/falApi";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined); // undefined = checking, null = anon, object = authed
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    try {
      const u = await apiMe();
      setUser(u);
    } catch (e) {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    // If returning from Google OAuth callback, let AuthCallback establish the session first.
    if (window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    checkAuth();
  }, [checkAuth]);

  const login = useCallback(async (email, password) => {
    const { user: u } = await apiLogin(email, password);
    setUser(u);
    return u;
  }, []);
  const register = useCallback(async (email, password, name) => {
    const { user: u } = await apiRegister(email, password, name);
    setUser(u);
    return u;
  }, []);
  const logout = useCallback(async () => {
    await apiLogout().catch((e) => console.error("Logout request failed", e));
    setUser(null);
  }, []);

  const value = useMemo(
    () => ({ user, setUser, loading, login, register, logout, refresh: checkAuth }),
    [user, loading, login, register, logout, checkAuth],
  );

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
